"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _createSuper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var service_1 = require("./service");

var Github = /*#__PURE__*/function (_service_1$Service) {
  _inherits(Github, _service_1$Service);

  var _super = _createSuper(Github);

  function Github() {
    _classCallCheck(this, Github);

    return _super.apply(this, arguments);
  }

  _createClass(Github, [{
    key: "getBaseUrls",
    value: function getBaseUrls() {
      var baseUrls = ['https://gist.github.com/', 'http://gist.github.com', 'gist.github.com'];
      return baseUrls;
    }
  }, {
    key: "normalizeUrl",
    value: function normalizeUrl(_proof) {
      return '';
    }
  }, {
    key: "getProofUrl",
    value: function getProofUrl(proof) {
      var baseUrls = this.getBaseUrls();
      var proofUrl = proof.proof_url.toLowerCase();
      proofUrl = _get(_getPrototypeOf(Github.prototype), "prefixScheme", this).call(this, proofUrl);

      for (var i = 0; i < baseUrls.length; i++) {
        var requiredPrefix = "".concat(baseUrls[i]).concat(proof.identifier).toLowerCase();

        if (proofUrl.startsWith(requiredPrefix)) {
          var raw = proofUrl.endsWith('/') ? 'raw' : '/raw';
          return "".concat(proofUrl).concat(raw);
        }
      }

      throw new Error("Proof url ".concat(proof.proof_url, " is not valid for service ").concat(proof.service));
    }
  }, {
    key: "getProofStatement",
    value: function getProofStatement(searchText, _cheerio) {
      return searchText;
    }
  }]);

  return Github;
}(service_1.Service);

exports.Github = Github;